import {
  IntIteratordtlvcwxsuu5a as IntIterator,
  CharIterator2h6gbyxoj1es2 as CharIterator,
} from '../collections/PrimitiveIterators.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import {
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
  Char__compareTo_impl_ypi4mb28h1l6umahrlb as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IntProgressionIteratorClass;
function IntProgressionIterator() {
  if (IntProgressionIteratorClass === VOID) {
    class $ extends IntIterator() {
      constructor(first, last, step) {
        super();
        this.xo_1 = step;
        this.yo_1 = last;
        this.zo_1 = this.xo_1 > 0 ? first <= last : first >= last;
        this.ap_1 = this.zo_1 ? first : this.yo_1;
      }
      q1() {
        return this.zo_1;
      }
      kk() {
        var value = this.ap_1;
        if (value === this.yo_1) {
          if (!this.zo_1)
            throw NoSuchElementException().t6();
          this.zo_1 = false;
        } else {
          this.ap_1 = this.ap_1 + this.xo_1 | 0;
        }
        return value;
      }
    }
    initMetadataForClass($, 'IntProgressionIterator');
    IntProgressionIteratorClass = $;
  }
  return IntProgressionIteratorClass;
}
var CharProgressionIteratorClass;
function CharProgressionIterator() {
  if (CharProgressionIteratorClass === VOID) {
    class $ extends CharIterator() {
      constructor(first, last, step) {
        super();
        this.bp_1 = step;
        var tmp = this;
        // Inline function 'kotlin.code' call
        tmp.cp_1 = Char__toInt_impl_vasixd(last);
        this.dp_1 = this.bp_1 > 0 ? Char__compareTo_impl_ypi4mb(first, last) <= 0 : Char__compareTo_impl_ypi4mb(first, last) >= 0;
        var tmp_0 = this;
        var tmp_1;
        if (this.dp_1) {
          // Inline function 'kotlin.code' call
          tmp_1 = Char__toInt_impl_vasixd(first);
        } else {
          tmp_1 = this.cp_1;
        }
        tmp_0.ep_1 = tmp_1;
      }
      q1() {
        return this.dp_1;
      }
      mk() {
        var value = this.ep_1;
        if (value === this.cp_1) {
          if (!this.dp_1)
            throw NoSuchElementException().t6();
          this.dp_1 = false;
        } else {
          this.ep_1 = this.ep_1 + this.bp_1 | 0;
        }
        return numberToChar(value);
      }
    }
    initMetadataForClass($, 'CharProgressionIterator');
    CharProgressionIteratorClass = $;
  }
  return CharProgressionIteratorClass;
}
//region block: exports
export {
  CharProgressionIterator as CharProgressionIterator34nq4ujuknl08,
  IntProgressionIterator as IntProgressionIterator2ovd1ctrmu51n,
};
//endregion

//# sourceMappingURL=ProgressionIterators.mjs.map
